import React, { useEffect, useState } from "react";
import Head from "next/head";
import { Col, Container, Row } from "react-bootstrap";
import webBanner from "../public/images/page_banner/plant_tree_web.png";
import mobBanner from "../public/images/page_banner/plant_tree_mob.png";
import Image from "next/image";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper";
import "swiper/css";
import "swiper/css/effect-fade";
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

const Plantree = () => {
  const [toggle, setToggle] = useState(false);
  Fancybox.bind("[data-fancybox]", {
    // Your custom options
    Hash: false,
  });

  return (
    <>
      <Head>
        <title>Plant a Tree Event - Township in North Kolkata</title>
        <meta
          name="description"
          content="Do you want to Celebrate Tree Plantation Day? New Kolkata, a township with affordable flats (1BHK, 2BHK, 3BHK) in North Kolkata conducted an event on 11th March, 2018 and invited people to participate. Apart from that, the event included a lot of fun activities, sumptuous food, and frill."
        />
        <meta
          name="keywords"
          content="Plant a Tree, Plant a Tree Event, Township in North Kolkata"
        />
      </Head>
      <section
        id="carouselExampleDark"
        className="carousel carousel-dark slide"
      >
        <div className="carousel-inner">
          <div className="carousel-item active" data-bs-interval="10000">
            <Image
              src={webBanner}
              className="d-none d-md-block  w-100"
              alt="banner"
              style={{ width: "auto", height: "auto" }}
            />

            <Image
              src={mobBanner}
              className="d-block d-md-none  w-100"
              alt="banner"
              style={{ width: "auto", height: "auto" }}
            />
          </div>
        </div>
      </section>
      <section className="sec-padd">
        <Container>
          <div className="head_wrap text-center">
            <div className="center-title">
              <h2
                className="section-title"
                data-aos="fade-up"
                data-aos-delay="100"
                data-aos-duration="1000"
              >
                <span>
                  Go Green with the Decoration of your Riverside Home!
                </span>
              </h2>
            </div>
          </div>
          <div
            className="inner_text "
            data-aos="fade-up"
            data-aos-delay="200"
            data-aos-duration="1000"
          >
            <p>
              It is time to decorate your Ganga facing home the ‘eco-friendly’
              way to initiate a healthy lifestyle. With the first step of
              planting a sapling, see yourself getting welcome with your own
              tree in your brand new home. The Green Habitant event held on 11th
              March 2018 at the New Kolkata, was initiated to encourage the
              potential buyers to plant their own tree and befriend greenery.
            </p>
            <p className="mb-0">
              The potential buyers of New Kolkata were invited to this day for
              the purpose of getting educated about the importance of planting
              trees so as to upgrade their lifestyle for the healthier one in
              their new home. Apart from that, the event included a lot of fun
              activities, sumptuous food, and frill which allowed the visitors
              to have a gala time.
            </p>
          </div>
        </Container>
      </section>
      <section>
        <Container fluid={true}>
          <div className="head_wrap text-center">
            <div className="center-title">
              <h2
                className="section-title"
                data-aos="fade-up"
                data-aos-delay="100"
                data-aos-duration="1000"
              >
                <span>Image Gallery</span>
              </h2>
            </div>
          </div>
          <Swiper
            modules={[Autoplay, Navigation]}
            autoplay={{
              delay: 2500,
              disableOnInteraction: false,
            }}
            navigation={{
              nextEl: ".cust-swiper-button-next",
              prevEl: ".cust-swiper-button-prev",
            }}
            loop={true}
            speed={1200}
            className="cust_slider"
            breakpoints={{
              767: {
                slidesPerView: 1,
                spaceBetween: 24,
              },
              992: {
                slidesPerView: 2,
                spaceBetween: 24,
              },
              1200: {
                slidesPerView: 3,
                spaceBetween: 24,
              },
            }}
          >
            <SwiperSlide>
              <div className="img-wrap image-container gall_wrp">
                <div
                  data-fancybox="plant_tree"
                  data-src="/images/green_habitant/plant_tree/1.jpeg"
                  className="img_overlay"
                >
                  <Image
                    fill
                    src="/images/green_habitant/plant_tree/1.jpeg"
                    alt="interior"
                    className="image"
                  />
                  <div className="gall_over"></div>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="img-wrap image-container gall_wrp">
                <div
                  data-fancybox="plant_tree"
                  data-src="/images/green_habitant/plant_tree/2.jpeg"
                  className="img_overlay"
                >
                  <Image
                    fill
                    src="/images/green_habitant/plant_tree/2.jpeg"
                    alt="interior"
                    className="image"
                  />
                  <div className="gall_over"></div>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="img-wrap image-container gall_wrp">
                <div
                  data-fancybox="plant_tree"
                  data-src="/images/green_habitant/plant_tree/3.jpeg"
                  className="img_overlay"
                >
                  <Image
                    fill
                    src="/images/green_habitant/plant_tree/3.jpeg"
                    alt="interior"
                    className="image"
                  />
                  <div className="gall_over"></div>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="img-wrap image-container gall_wrp">
                <div
                  data-fancybox="plant_tree"
                  data-src="/images/green_habitant/plant_tree/4.jpeg"
                  className="img_overlay"
                >
                  <Image
                    fill
                    src="/images/green_habitant/plant_tree/4.jpeg"
                    alt="interior"
                    className="image"
                  />
                  <div className="gall_over"></div>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="img-wrap image-container gall_wrp">
                <div
                  data-fancybox="plant_tree"
                  data-src="/images/green_habitant/plant_tree/5.jpeg"
                  className="img_overlay"
                >
                  <Image
                    fill
                    src="/images/green_habitant/plant_tree/5.jpeg"
                    alt="interior"
                    className="image"
                  />
                  <div className="gall_over"></div>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="img-wrap image-container gall_wrp">
                <div
                  data-fancybox="plant_tree"
                  data-src="/images/green_habitant/plant_tree/6.jpeg"
                  className="img_overlay"
                >
                  <Image
                    fill
                    src="/images/green_habitant/plant_tree/6.jpeg"
                    alt="interior"
                    className="image"
                  />
                  <div className="gall_over"></div>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="img-wrap image-container gall_wrp">
                <div
                  data-fancybox="plant_tree"
                  data-src="/images/green_habitant/plant_tree/7.jpeg"
                  className="img_overlay"
                >
                  <Image
                    fill
                    src="/images/green_habitant/plant_tree/7.jpeg"
                    alt="interior"
                    className="image"
                  />
                  <div className="gall_over"></div>
                </div>
              </div>
            </SwiperSlide>
            <div className="swiper-nav mt-4">
              <button className="fa-solid fa-chevron-left cust-swiper-button-prev">
                <span>prev</span>
              </button>
              <button className="fa-solid fa-chevron-right cust-swiper-button-next">
                <span>next</span>
              </button>
            </div>
          </Swiper>
        </Container>
        <Container>
          <div className="mt-3 mt-md-5">
            <div className="head_wrap text-center">
              <div className="center-title">
                <h2
                  className="section-title"
                  data-aos="fade-up"
                  data-aos-delay="100"
                  data-aos-duration="1000"
                >
                  <span>Video Gallery</span>
                </h2>
              </div>
            </div>
            <Row className="justify-content-center">
              <Col md={8}>
                <div className="video">
                  <div className="img-wrap image-container gall_wrp">
                    <div
                      data-fancybox="video"
                      data-src="https://www.youtube.com/embed/JcHp6I2_3pM"
                      className="img_overlay"
                    >
                      <Image
                        fill
                        src="/images/green_habitant/plant_tree/video_thumb.jpg"
                        alt="interior"
                        className="image"
                      />
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </Container>
      </section>
      <section className="sec-padd water_mark">
        <Container>
          <div className="head_wrap text-center">
            <div className="center-title">
              <h2
                className="section-title"
                data-aos="fade-up"
                data-aos-delay="100"
                data-aos-duration="1000"
              >
                <span>In the News</span>
              </h2>
            </div>
          </div>
          <ul className="press-release-list">
            <li>
              <div className="press-img">
                <Image
                  fill
                  className="image"
                  alt="news"
                  src="/images/green_habitant/plant_tree/img01.jpg"
                />
              </div>
              <div className="press-details">
                <h4>A NEW KOLKATA IS WAITING FOR YOU</h4>
                <div className="date-time">
                  <i className="fa fa-calendar calender-icon"></i>
                  <span>Monday, 19 Mar</span>
                </div>
                <p>
                  Ever wondered how it feels to get up in the morning and watch
                  the divine Ganges right outside your window?
                </p>
                <a
                  className="read-more"
                  href="http://allthingssassy.winkl.co/content/a-new-kolkata-is-waiting-for-you"
                  target="_blank"
                >
                  Read More
                </a>
              </div>
            </li>
            <li>
              <div className="press-img">
                <Image
                  fill
                  className="image"
                  alt="news"
                  src="/images/green_habitant/plant_tree/img02.jpg"
                />
              </div>
              <div className="press-details">
                <h4>
                  Affordable Flats in Kolkata Where Dream Living Comes True
                </h4>
                <div className="date-time">
                  <i className="fa fa-calendar calender-icon"></i>
                  <span>Tuesday, 20 Mar</span>
                </div>
                <p>
                  New Kolkata, must be your first choice if you are looking for
                  flats in Kolkata. Definitely, New Kolkata meets
                </p>
                <a
                  className="read-more"
                  href="http://aroundlife.winkl.co/content/new-kolkata-by-alcove"
                  target="_blank"
                >
                  Read More
                </a>
              </div>
            </li>
            <li>
              <div className="press-img">
                <Image
                  fill
                  className="image"
                  alt="news"
                  src="/images/green_habitant/plant_tree/img03.jpg"
                />
              </div>
              <div className="press-details">
                <h4>New Kolkata – A New City</h4>
                <div className="date-time">
                  <i className="fa fa-calendar calender-icon"></i>
                  <span>Tuesday, 20 Mar</span>
                </div>
                <p>
                  A recent visit to the project site of Alcove Realty’s New
                  Kolkata, made me witness at amaze that amidst
                </p>
                <a
                  className="read-more"
                  href="https://theorangeepistles.wordpress.com/2018/03/20/new-kolkata/"
                  target="_blank"
                >
                  Read More
                </a>
              </div>
            </li>
            <li>
              <div className="press-img">
                <Image
                  fill
                  className="image"
                  alt="news"
                  src="/images/green_habitant/plant_tree/img04.jpg"
                />
              </div>
              <div className="press-details">
                <h4>
                  Luxury Flats Under Your Budget in Kolkata : New Kolkata,
                  Alcove
                </h4>
                <div className="date-time">
                  <i className="fa fa-calendar calender-icon"></i>
                  <span>Tuesday, 20 Mar</span>
                </div>
                <p>
                  I have always been fascinated with rivers and the sounds of
                  birds in the morning. I always dream about a house
                </p>
                <a
                  className="read-more"
                  href="https://www.throughmypinkwindow.com/2018/03/luxury-flats-under-your-budget-in-kolkata-new-kolkata-alcove.html"
                  target="_blank"
                >
                  Read More
                </a>
              </div>
            </li>
            <li>
              <div className="press-img">
                <Image
                  fill
                  className="image"
                  alt="news"
                  src="/images/green_habitant/plant_tree/img05.jpg"
                />
              </div>
              <div className="press-details">
                <h4>NEW KOLKATA Away From Kolkata | My Little Corner</h4>
                <div className="date-time">
                  <i className="fa fa-calendar calender-icon"></i>
                  <span>Tuesday, 20 Mar</span>
                </div>
                <p>
                  How many of you have always wanted to live in one of those
                  lavish apartments? Well, I clearly have!
                </p>
                <a
                  className="read-more"
                  href="https://mylittlecornerbydeblinac.wordpress.com/2018/03/20/new-kolkata-away-from-kolkata-my-little-corner/"
                  target="_blank"
                >
                  Read More
                </a>
              </div>
            </li>
            <li>
              <div className="press-img">
                <Image
                  fill
                  className="image"
                  alt="news"
                  src="/images/green_habitant/plant_tree/img06.jpg"
                />
              </div>
              <div className="press-details">
                <h4>HOME BY THE GANGES-NEW KOLKATA BY ALCOVE</h4>
                <div className="date-time">
                  <i className="fa fa-calendar calender-icon"></i>
                  <span>Tuesday, 20 Mar</span>
                </div>
                <p>
                  Home by The Ganges. Your dream will come true now. New Kolkata
                  by Alcove will be the tallest tower in Serampore
                </p>
                <a
                  className="read-more"
                  href="http://thetinkersoul.com/home-by-the-ganges-new-kolkata-by-alcove/"
                  target="_blank"
                >
                  Read More
                </a>
              </div>
            </li>
          </ul>
        </Container>
      </section>
    </>
  );
};

export default Plantree;
